/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {SideBar} from './styles';

export default () => <SideBar></SideBar>;
